export default "__VITE_ASSET__CCbOMPoW__"